import React from 'react'
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group'
import { AlertCircle } from 'lucide-react'

const WindowLocksSection = ({
  showWindowLocks,
  formData,
  errors,
  handleInputChange,
  isDark
}) => {
  if (!showWindowLocks) return null

  return (
    <>
    <div className={`rounded-[16px] p-[20px] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
      isDark ? 'bg-[#292929] border-none shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)]' : 'bg-[#fff5eb] border-none shadow-[0px_0px_6px_1px_rgba(0,0,0,0.08)]'
    }`}>
      <div>
        <span className={`font-medium text-[16px] transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>Was the quotes for window locks approved? <span className="text-[#FF0000]">*</span></span>
        <RadioGroup
          className="flex flex-col gap-[12px] mt-[12px]"
          value={formData.windowLockApproval || ''}
          onValueChange={(v)=>handleInputChange('windowLockApproval', v)}
          name="windowLockApproval"
        >
          <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#000]'
          }`}>
            <RadioGroupItem value="no" id="wl-approval-no" />
            <span>No</span>
          </label>
          <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#000]'
          }`}>
            <RadioGroupItem value="yes_qsec" id="wl-approval-yes-qsec" />
            <span>Yes, Qsec</span>
          </label>
          <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#000]'
          }`}>
            <RadioGroupItem value="yes" id="wl-approval-yes" />
            <span>Yes</span>
          </label>
        </RadioGroup>
      </div>

      {formData.windowLockApproval === 'yes' && (
        <div className="flex flex-col gap-[8px]">
          <span className={`font-medium text-[16px] transition-colors duration-200  ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>Contractor name</span>
          <input
            className={`px-[12px] py-[10px] text-[16px] rounded-[8px] w-full transition-colors duration-200 outline-none ${
              errors.contractorName
                ? 'border-[#FF0000]'
                : ''
            } ${
              isDark
                ? 'bg-[#000000] text-white placeholder:text-[#b3b3b3] border-none focus:border-[#CD6D2C] focus:border-solid focus:border-[1px]'
                : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa] text-[#072837] placeholder:text-[#686868] focus:border-[#CD6D2C]'
            }`}
            type='text'
            placeholder='Enter contractor name'
            value={formData.contractorName}
            onChange={(e)=>handleInputChange('contractorName', e.target.value)}
          />
        </div>
      )}

      {(formData.windowLockApproval === 'yes' || formData.windowLockApproval === 'yes_qsec') && (
        <div className="flex flex-col gap-[12px]">
          <span className={`font-medium text-[16px] transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>Proceed with <span className="text-[#FF0000]">*</span></span>
          <RadioGroup
            className="flex flex-col gap-[12px]"
            value={formData.windowLockProceedWith || ''}
            onValueChange={(v)=>handleInputChange('windowLockProceedWith', v)}
            name="windowLockProceedWith"
          >
            <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#000]'
            }`}>
              <RadioGroupItem value="work_order" id="wl-proceed-work" />
              <span>Work order</span>
            </label>
            <label className={`inline-flex items-center gap-[8px] text-[14px] transition-colors duration-200 ${
              isDark ? 'text-white' : 'text-[#000]'
            }`}>
              <RadioGroupItem value="obtain_quotes" id="wl-proceed-quotes" />
              <span>Obtain quotes</span>
            </label>
          </RadioGroup>
        </div>
      )}

      {(formData.windowLockApproval === 'yes' || formData.windowLockApproval === 'yes_qsec') && (
        <div className="flex flex-col gap-[8px]">
          <span className={`font-medium text-[16px] transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>Are there any special requests in respect of the window locks?</span>
          <input
            className={`px-[12px] py-[10px] text-[16px] rounded-[8px] w-full transition-colors duration-200 outline-none ${
              errors.windowLockSpecialRequests
                ? 'border-[#FF0000]'
                : ''
            } ${
              isDark
                ? 'bg-[#000000] text-white placeholder:text-[#b3b3b3] border-none focus:border-[#CD6D2C] focus:border-solid focus:border-[1px]'
                : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa] text-[#072837] placeholder:text-[#686868] focus:border-[#CD6D2C]'
            }`}
            placeholder='Enter any special requests...'
            value={formData.windowLockSpecialRequests}
            onChange={(e)=>handleInputChange('windowLockSpecialRequests', e.target.value)}
          />
        </div>
      )}

    </div>
    {errors.windowLockApproval && (
      <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
        <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
        <span className="leading-[1.4]">Please select whether the quotes for window locks were approved.</span>
      </div>
    )}
    {!errors.windowLockApproval && errors.contractorName && (
      <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
        <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
        <span className="leading-[1.4]">Contractor name is required when selecting "Yes".</span>
      </div>
    )}
    {!errors.windowLockApproval && !errors.contractorName && errors.windowLockProceedWith && (
      <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
        <AlertCircle className="w-[16px] h-[16px] flex-shrink-0" />
        <span className="leading-[1.4]">Please select how to proceed with the window locks.</span>
      </div>
    )}
    </>
  )
}

export default WindowLocksSection


